module.exports = __webpack_public_path__ + "static/media/total-exam.8d430ece.svg";